import { useState, createContext, useContext, ReactNode } from 'react'
import { IContainer } from '@/containers/logistic/containers/interfaces/interfaces'
import { mockedData } from '@/containers/logistic/containers/mock/mocked'
import { useQueryClient } from '@tanstack/react-query'
import { GET_ALL_CONTAINERS_QUERY_KEY } from '@/containers/logistic/containers/hooks/useServerLogisticContainer'

const LogisticContainerContext = createContext<any>(null)

export function LogisticContainerProvider({ children }: { children: ReactNode }) {
  const queryClient = useQueryClient()

  const [editContainer, setEditContainer] = useState<IContainer | undefined>()
  const [showNewContainer, setShowNewContainer] = useState<boolean>(false)
  const refetch = () =>
    queryClient.invalidateQueries({ queryKey: [GET_ALL_CONTAINERS_QUERY_KEY] })

  const [dataTable, setDataTable] = useState<IContainer[]>(
    mockedData.slice(0, 5)
  )
  const [currentPage, setCurrentPage] = useState(1)

  const goToPage = (page: number) => {
    setCurrentPage(page)
    setDataTable(mockedData.slice((page - 1) * 5, page * 5))
  }
  const goToNextPage = () => {
    setCurrentPage(currentPage + 1)
    setDataTable(mockedData.slice(currentPage * 5, (currentPage + 1) * 5))
  }
  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1)
    setDataTable(mockedData.slice((currentPage - 2) * 5, (currentPage - 1) * 5))
  }

  const search = {
    action: (searchQuery: string) => {
      if (searchQuery !== '')
        setDataTable(
          mockedData.filter((item) =>
            item.operationNumber.toString().includes(searchQuery)
          )
        )
      else
        setDataTable(mockedData.slice((currentPage - 1) * 5, currentPage * 5))
    },
    placeholder: 'Buscar contenedor',
  }

  const onCloseWizard = () => {
    setEditContainer(undefined)
    setShowNewContainer(false)
  }

  const paginate = {
    currentPage: currentPage,
    totalItems: mockedData.length,
    goToPage,
    goToNextPage,
    goToPreviousPage,
  }

  const onRowClick = (row: IContainer) => {
    setEditContainer(row)
    setShowNewContainer(true)
  }

  const onNewContainer = () => {
    setEditContainer(undefined)
    setShowNewContainer(true)
  }
  const onChangeFilter = (newFilters: Record<string, string>) => {
    setDataTable(
      mockedData.filter((item) => newFilters['status'].includes(item.status))
    )
  }

  const contextValue = {
    dataTable,
    search,
    refetch,
    paginate,
    onRowClick,
    editContainer,
    showNewContainer,
    onNewContainer,
    onCloseWizard,
    onChangeFilter,
  }

  return (
    <LogisticContainerContext.Provider value={contextValue}>
      {children}
    </LogisticContainerContext.Provider>
  )
}

export function useLogisticContainer() {
  const context = useContext(LogisticContainerContext)
  if (!context) {
    throw new Error('useLogisticContainer must be used within a LogisticContainerProvider')
  }
  return context
} 